import { ComponentProps } from 'react'

import { assertNever } from 'src/utils/assertNever'

import { ErrorIndicatorIcon } from '../components/ErrorIndicatorIcon/ErrorIndicatorIcon'

export type ControlButtonType = 'normal' | 'floating-video-player' | 'sp'

export const getButtonSize = (type: ControlButtonType) => {
  switch (type) {
    case 'normal':
      return '48px'
    case 'floating-video-player':
    case 'sp':
      return '32px'
    default:
      return assertNever(type)
  }
}

export const getIndicatorProps = (
  type: ControlButtonType,
): ComponentProps<typeof ErrorIndicatorIcon> => {
  switch (type) {
    case 'normal':
      return {
        size: '24px',
        pos: 'absolute',
        top: '-10px',
        right: '-6px',
      }
    case 'floating-video-player':
      return {
        size: '14px',
        pos: 'absolute',
        top: '-4px',
        right: '-2px',
      }
    case 'sp':
      return {
        size: '14px',
        pos: 'absolute',
        top: '-6px',
        right: '-2px',
      }
    default:
      return assertNever(type)
  }
}

export const getIconSize = (type: ControlButtonType): `${number}px` => {
  switch (type) {
    case 'normal':
      return '24px'
    case 'floating-video-player':
    case 'sp':
      return '16px'
    default:
      return assertNever(type)
  }
}
